/** Tickets list (table avanzata) */
import React from 'react';
import { Search, Filter, Plus, Droplets, Zap, Wind, Tv, AlertOctagon, MoreHorizontal,
  Clock, ArrowUpDown, Download } from 'lucide-react';
import { C, fontHead, overline, primaryBtn } from '../_tokens';

const tickets = [
  { id: 'TKT-2847', pr: 'urg', cat: 'idraulica', icon: Droplets, room: 'Cam 208', hotel: 'Galleria', title: 'Perdita continua scarico lavabo, allagamento parziale', tech: 'Luca M.', age: '2m', sla: '-3m', photos: 2 },
  { id: 'TKT-2846', pr: 'urg', cat: 'hvac', icon: Wind, room: 'Lobby', hotel: 'Arcimboldi', title: 'AC centrale spenta da 14 min', tech: 'In attesa', age: '14m', photos: 0 },
  { id: 'TKT-2845', pr: 'high', cat: 'electrical', icon: Zap, room: 'Cam 412', hotel: 'Scarlatti', title: 'Presa lato letto fuori uso, ospite anziano', tech: 'Marco T.', age: '42m', photos: 1 },
  { id: 'TKT-2844', pr: 'high', cat: 'ascens', icon: AlertOctagon, room: 'Cabina B', hotel: 'Kira', title: 'Pulsantiera intermittente, fermata 3° piano', tech: 'Sara K.', age: '1h 4m', photos: 0 },
  { id: 'TKT-2843', pr: 'medium', cat: 'electro', icon: Tv, room: 'Cam 305', hotel: 'Galleria', title: 'TV: ingresso HDMI non rilevato dopo riavvio', tech: 'Sara K.', age: '1h 12m', photos: 0 },
  { id: 'TKT-2842', pr: 'medium', cat: 'idraulica', icon: Droplets, room: 'Cam 109', hotel: 'Vivaldi', title: 'Rubinetto bagno gocciola, verificato in loco', tech: 'Luca M.', age: '2h 30m', photos: 1 },
  { id: 'TKT-2841', pr: 'low', cat: 'idraulica', icon: Droplets, room: 'Cam 118', hotel: 'Heart', title: 'Silicone giallo bordo doccia (basso impatto)', tech: 'Da assegnare', age: '3h', photos: 1 },
  { id: 'TKT-2840', pr: 'low', cat: 'electrical', icon: Zap, room: 'Cam 502', hotel: 'Arcimboldi', title: 'Lampadina abat-jour fulminata', tech: 'Marco T.', age: '4h 20m', photos: 0 },
];

const prMap = {
  urg: { label: 'URGENTE', color: C.terra },
  high: { label: 'ALTA', color: '#F59E0B' },
  medium: { label: 'MEDIA', color: '#FBBF24' },
  low: { label: 'BASSA', color: '#64748B' },
};

export default function ScreenTickets() {
  return (
    <div style={{ padding: '32px 36px', minHeight: '100%', background: C.bg, color: C.text, fontFamily: 'Inter' }}>
      {/* HEADER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 28 }}>
        <div>
          <div style={{ ...overline, marginBottom: 6 }}>Operations · Tickets</div>
          <h1 style={{ fontFamily: fontHead, fontSize: 38, fontWeight: 600, margin: 0,
                       letterSpacing: '-0.025em', lineHeight: 1 }}>
            Tutti i ticket
            <span style={{ color: C.textSec, fontSize: 22, fontWeight: 400, marginLeft: 14 }}>· 8 di 47</span>
          </h1>
          <div style={{ color: C.textSec, fontSize: 13, marginTop: 8 }}>
            3 urgenti · 12 alta priorità · 19 media · 13 bassa
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={{ ...primaryBtn }}><Plus size={14} /> Nuovo ticket</button>
          <button style={{
            background: C.surf, color: C.text, border: `1px solid ${C.border}`,
            padding: '10px 14px', borderRadius: 10, fontWeight: 500, fontSize: 13, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6,
          }}>
            <Download size={14} /> Esporta
          </button>
        </div>
      </div>

      {/* FILTER BAR */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 18, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8, padding: '9px 14px',
          background: C.surf, borderRadius: 10, border: `1px solid ${C.border}`, minWidth: 340,
        }}>
          <Search size={14} color={C.textSec} />
          <span style={{ color: C.textSec, fontSize: 13 }}>Cerca per titolo, camera, ID...</span>
        </div>
        <Pill label="Tutti gli hotel" />
        <Pill label="Priorità" />
        <Pill label="Categoria" />
        <Pill label="Stato" active />
        <Pill label="Operatore" />
        <button style={{
          background: 'transparent', color: C.textSec, border: 'none', fontSize: 12,
          cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5,
        }}>
          <Filter size={12} /> 1 filtro attivo · pulisci
        </button>
      </div>

      {/* TABLE */}
      <div style={{ background: C.surf, borderRadius: 16, border: `1px solid ${C.border}`, overflow: 'hidden' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '24px 110px 120px 1fr 110px 120px 100px 30px',
          gap: 14, padding: '14px 22px', borderBottom: `1px solid ${C.border}`,
          fontSize: 10.5, letterSpacing: '0.12em', textTransform: 'uppercase',
          color: C.textSec, fontWeight: 600, alignItems: 'center',
        }}>
          <span></span>
          <span>ID</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>Prio <ArrowUpDown size={10} /></span>
          <span>Descrizione</span>
          <span>Hotel</span>
          <span>Assegnato a</span>
          <span style={{ textAlign: 'right' }}>Apertura</span>
          <span></span>
        </div>
        {tickets.map((t, i) => (
          <div key={t.id} style={{
            display: 'grid',
            gridTemplateColumns: '24px 110px 120px 1fr 110px 120px 100px 30px',
            gap: 14, padding: '16px 22px',
            borderBottom: i < tickets.length - 1 ? `1px solid ${C.border}` : 'none',
            alignItems: 'center', cursor: 'pointer',
            background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.012)',
          }}>
            <div style={{
              width: 4, height: 36, borderRadius: 12, background: prMap[t.pr].color,
              boxShadow: t.pr === 'urg' ? `0 0 8px ${prMap[t.pr].color}` : 'none',
            }} />
            <span style={{ fontFamily: 'monospace', fontSize: 11, color: C.textSec }}>{t.id}</span>
            <span style={{
              fontSize: 10, fontWeight: 700, letterSpacing: '0.08em',
              padding: '3px 8px', borderRadius: 5,
              background: `${prMap[t.pr].color}22`, color: prMap[t.pr].color,
              width: 'fit-content',
            }}>{prMap[t.pr].label}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
              <div style={{
                width: 32, height: 32, borderRadius: 8, background: `${prMap[t.pr].color}1a`,
                display: 'grid', placeItems: 'center', flexShrink: 0,
              }}><t.icon size={14} color={prMap[t.pr].color} /></div>
              <div style={{ minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontWeight: 600, fontSize: 13 }}>{t.room}</span>
                  {t.sla && <span style={{
                    fontSize: 9.5, color: C.terra, fontWeight: 700,
                    padding: '1px 6px', background: `${C.terra}22`, borderRadius: 4,
                  }}>SLA {t.sla}</span>}
                  {t.photos > 0 && <span style={{
                    fontSize: 9.5, padding: '1px 6px', borderRadius: 4,
                    background: `${C.gold}22`, color: C.gold, fontWeight: 600,
                  }}>📷 {t.photos}</span>}
                </div>
                <div style={{ fontSize: 12.5, color: C.text, opacity: 0.92,
                              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                              marginTop: 3 }}>{t.title}</div>
              </div>
            </div>
            <span style={{ fontSize: 12.5, color: C.text }}>{t.hotel}</span>
            <span style={{ fontSize: 12.5, color: t.tech.startsWith('In ') || t.tech.startsWith('Da') ? C.textSec : C.text }}>
              {t.tech}
            </span>
            <span style={{ fontSize: 12, color: C.textSec, textAlign: 'right',
                           display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'flex-end' }}>
              <Clock size={11} /> {t.age}
            </span>
            <MoreHorizontal size={15} color={C.textSec} />
          </div>
        ))}
      </div>

      {/* PAGINATION */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 18, fontSize: 12 }}>
        <span style={{ color: C.textSec }}>Mostrati 8 di 47 ticket</span>
        <div style={{ display: 'flex', gap: 6 }}>
          {['1', '2', '3', '4', '5', '6'].map((p, i) => (
            <button key={p} style={{
              minWidth: 30, height: 30, borderRadius: 7,
              background: i === 0 ? `${C.gold}22` : 'transparent',
              border: `1px solid ${i === 0 ? C.gold + '55' : C.border}`,
              color: i === 0 ? C.gold : C.textSec,
              fontSize: 12, cursor: 'pointer', fontWeight: 600,
            }}>{p}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

const Pill = ({ label, active }) => (
  <button style={{
    padding: '8px 14px', borderRadius: 999, fontSize: 12,
    background: active ? `${C.gold}22` : C.surf,
    color: active ? C.gold : C.textSec,
    border: `1px solid ${active ? C.gold + '55' : C.border}`,
    cursor: 'pointer', fontWeight: active ? 600 : 400,
  }}>{label}</button>
);
